import React from "react";
import "./PrivacyPolicy.css";

function PrivacyPolicy() {
  return (
    <div className="privacy-container">
      <div className="privacy-header">
        <h1>Privacy Policy</h1>
        <p>Last Updated on 17-10-2025</p>
      </div>

      <div className="privacy-content">
        <p>
          Welcome to <strong>DevSkillZ Learning HUB</strong> (“we,” “our,” or “us”). We value your trust
          and are committed to protecting your personal information. This Privacy Policy explains
          how we collect, use, and safeguard your data when you interact with our website, online
          forms, training programs, workshops, and internship initiatives.
        </p>

        <h2>1. Information We Collect</h2>
        <ul>
          <li>
            <strong>Personal Information:</strong> Name, email, phone, educational details, resume/LinkedIn,
            address if required.
          </li>
          <li>
            <strong>Payment Information:</strong> Transaction details, payment mode, and confirmation.
          </li>
          <li>
            <strong>Usage Information:</strong> Device type, browser, IP address, pages visited, time spent.
          </li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <ul>
          <li>Process registrations for internships, workshops, or courses</li>
          <li>Issue certificates</li>
          <li>Communicate updates, webinars, and placement opportunities</li>
          <li>Improve services and ensure compliance</li>
        </ul>

        <h2>3. Information Sharing and Disclosure</h2>
        <p>
          We do not sell, rent, or trade your personal data. Limited sharing may occur with:
          trainers, partner organizations (with consent), payment providers, or legal authorities.
        </p>

        <h2>4. Data Security</h2>
        <p>We use industry-standard security measures to protect your information.</p>

        <h2>5. Your Rights</h2>
        <p>
          You may access, correct, or request deletion of your personal data by contacting us at
          <strong> info@devskillz.com</strong>.
        </p>

        <h2>6. Data Retention</h2>
        <p>
          We retain data only as long as necessary for internships, certificates, legal obligations,
          and then archive or anonymize it securely.
        </p>

        <h2>7. Third-Party Links</h2>
        <p>
          Links to third-party platforms (Google Forms, payment gateways, webinars) are not
          controlled by us. Please review their policies.
        </p>

        <h2>8. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy periodically. Updates will be posted on our website
          with an updated “Effective Date.”
        </p>

        <h2>9. Contact Us</h2>
        <p>
          Email: <a href="mailto:devskillzlearning@gmail.com">devskillzlearning@gmail.com</a><br />
          Website: <a href="https://www.devskillz.in" target="_blank" rel="noopener noreferrer">https://www.devskillz.in</a><br />
          Address: First Floor, Plot no 21, Beach Rd, Kirlampudi Layout, Chinna Waltair, Pedda Waltair, Visakhapatnam, Andhra Pradesh 530017
        </p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
